import ROLE from "enums/ROLE_NAME";

export default interface Role {
  name: ROLE;
  id: string;
}

export const RoleHierarchy = [
  ROLE.USER,
  ROLE.ACCOUNT_SEARCHER,
  ROLE.VIEWER,
  ROLE.ADMIN_NOPII,
  ROLE.ADMIN,
  ROLE.SUPER_ADMIN,
  ROLE.SUPER_DUPER_ADMIN,
];
